// services/profile.js
import api from './api';

const UPLOADS_URL = 'https://murima.julesferry-ga.com/uploads/';

class ProfileService {
  
  /**
   * Récupère le profil d'un utilisateur
   * @param {number} profileId - ID du profil à consulter
   * @param {number} currentUserId - ID de l'utilisateur connecté
   */
  async getProfile(profileId, currentUserId) {
    try {
      const response = await api.get(`/get-profile.php?profile_id=${profileId}&current_user_id=${currentUserId}`);
      
      console.log('📥 ProfileService.getProfile - Réponse:', response.data);
      
      if (response.data.success) {
        const data = response.data;
        
        return {
          success: true,
          user: {
            ...data.user,
            age: this.calculateAge(data.user.date_naissance),
            avatar: data.user.avatar ? `${UPLOADS_URL}${data.user.avatar}` : null,
            cover: data.user.cover_photo ? `${UPLOADS_URL}${data.user.cover_photo}` : null,
            en_ligne: Boolean(data.user.en_ligne),
            is_verified: Boolean(data.user.is_verified),
            is_premium: Boolean(data.user.is_premium)
          },
          interests: data.interests || [],
          photos: (data.photos || []).map(photo => ({
            ...photo,
            url: photo.url.startsWith('http') ? photo.url : `${UPLOADS_URL}${photo.url}`,
            est_privee: Boolean(photo.est_privee)
          })),
          videos: (data.videos || []).map(video => ({
            ...video,
            url: video.url.startsWith('http') ? video.url : `${UPLOADS_URL}${video.url}`,
            thumbnail: video.thumbnail ? (video.thumbnail.startsWith('http') ? video.thumbnail : `${UPLOADS_URL}${video.thumbnail}`) : null,
            est_privee: Boolean(video.est_privee),
            vues: parseInt(video.vues) || 0,
            likes: parseInt(video.likes) || 0
          })),
          already_liked: data.already_liked || false,
          is_match: data.is_match || false,
          is_favorite: data.is_favorite || false,
          is_following: data.is_following || false
        };
      }
      
      return { 
        success: false, 
        error: response.data.error || 'Erreur lors du chargement du profil' 
      };
      
    } catch (error) {
      console.error('❌ ProfileService.getProfile - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur de connexion' 
      };
    }
  }

  /**
   * Liker un utilisateur
// services/profile.js - Version corrigée de likeUser

/**
 * Liker un utilisateur
 * @param {number} targetUserId - ID de l'utilisateur à liker (le profil consulté)
 */
async likeUser(targetUserId) {
  try {
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    
    if (!currentUser?.id) {
      return { 
        success: false, 
        error: 'Utilisateur non connecté' 
      };
    }

    // Vérification côté client
    if (currentUser.id === targetUserId) {
      return {
        success: false,
        error: 'Vous ne pouvez pas vous liker vous-même'
      };
    }

    console.log('📤 Like User - from:', currentUser.id, 'to:', targetUserId);

    const response = await api.post('/like.php', {
      user_id: currentUser.id,      // L'utilisateur connecté (from)
      to_user_id: targetUserId       // L'utilisateur cible (to)
    });

    console.log('📥 Like User Response:', response.data);
    return response.data;
    
  } catch (error) {
    console.error('❌ likeUser error:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Erreur réseau' 
    };
  }
}
  /**
   * Ajouter aux favoris
   * @param {number} userId - ID de l'utilisateur à ajouter aux favoris
   */
  async addFavorite(userId) {
    try {
      const response = await api.post('/add-favorite.php', {
        user_id: userId,
        favori_id: userId
      });

      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.addFavorite - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur réseau' 
      };
    }
  }

  /**
   * Retirer des favoris
   * @param {number} userId - ID de l'utilisateur à retirer des favoris
   */
  async removeFavorite(userId) {
    try {
      const response = await api.post('/remove-favorite.php', {
        user_id: userId,
        favori_id: userId
      });

      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.removeFavorite - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur réseau' 
      };
    }
  }

  /**
   * Suivre un utilisateur
 * @param {number} targetUserId - ID de l'utilisateur à suivre (le profil consulté)
   */
  async followUser(targetUserId) {
    try {
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (!currentUser?.id) {
        return { 
          success: false, 
          error: 'Utilisateur non connecté' 
        };
      }

      // Vérification côté client
      if (currentUser.id === targetUserId) {
        return {
          success: false,
          error: 'Vous ne pouvez pas vous suivre vous-même'
        };
      }

      console.log('📤 Follow User - follower:', currentUser.id, 'following:', targetUserId);

      const response = await api.post('/follow-user.php', {
        user_id: currentUser.id,
        following_id: targetUserId
      });

      console.log('📥 Follow User Response:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ followUser error:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur réseau' 
      };
    }
  }

  /**
   * Ne plus suivre un utilisateur
   * @param {number} targetUserId - ID de l'utilisateur à ne plus suivre
   */
  async unfollowUser(targetUserId) {
    try {
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (!currentUser?.id) {
        return { 
          success: false, 
          error: 'Utilisateur non connecté' 
        };
      }

      console.log('📤 Unfollow User - follower:', currentUser.id, 'following:', targetUserId);

      const response = await api.post('/unfollow-user.php', {
        user_id: currentUser.id,
        following_id: targetUserId
      });

      console.log('📥 Unfollow User Response:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ unfollowUser error:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur réseau' 
      };
    }
  }
  /**
   * Mettre à jour le profil
   * @param {Object} data - Données du profil à mettre à jour
   */
  async updateProfile(data) {
    try {
      const response = await api.post('/update-profile.php', data);
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.updateProfile - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur de mise à jour' 
      };
    }
  }

  /**
   * Uploader un avatar
   * @param {File} file - Fichier image
   */
  async uploadAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'avatar');
    formData.append('user_id', JSON.parse(localStorage.getItem('user') || '{}')?.id || '');

    try {
      const response = await api.post('/upload.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.success) {
        return {
          success: true,
          url: response.data.url,
          message: 'Avatar mis à jour avec succès'
        };
      }
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.uploadAvatar - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur d\'upload' 
      };
    }
  }

  /**
   * Uploader une photo de couverture
   * @param {File} file - Fichier image
   */
  async uploadCover(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'cover');
    formData.append('user_id', JSON.parse(localStorage.getItem('user') || '{}')?.id || '');

    try {
      const response = await api.post('/upload.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.success) {
        return {
          success: true,
          url: response.data.url,
          message: 'Photo de couverture mise à jour'
        };
      }
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.uploadCover - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur d\'upload' 
      };
    }
  }

  /**
   * Uploader une photo
   * @param {File} file - Fichier image
   * @param {boolean} isPrivate - Photo privée ou non
   */
  async uploadPhoto(file, isPrivate = false) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'photo');
    formData.append('is_private', isPrivate ? '1' : '0');
    formData.append('user_id', JSON.parse(localStorage.getItem('user') || '{}')?.id || '');

    try {
      const response = await api.post('/upload.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.uploadPhoto - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur d\'upload' 
      };
    }
  }

  /**
   * Uploader une vidéo
   * @param {File} file - Fichier vidéo
   * @param {string} titre - Titre de la vidéo
   * @param {boolean} isPrivate - Vidéo privée ou non
   */
  async uploadVideo(file, titre, isPrivate = false) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'video');
    formData.append('titre', titre);
    formData.append('is_private', isPrivate ? '1' : '0');
    formData.append('user_id', JSON.parse(localStorage.getItem('user') || '{}')?.id || '');

    try {
      const response = await api.post('/upload.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.uploadVideo - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur d\'upload' 
      };
    }
  }

  /**
   * Supprimer un média
   * @param {string} type - Type de média ('photo' ou 'video')
   * @param {number} id - ID du média
   */
  async deleteMedia(type, id) {
    try {
      const endpoint = type === 'photo' ? '/delete-photo.php' : '/delete-video.php';
      const idField = type === 'photo' ? 'photo_id' : 'video_id';
      
      const response = await api.post(endpoint, {
        [idField]: id,
        user_id: JSON.parse(localStorage.getItem('user') || '{}')?.id || ''
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.deleteMedia - Erreur:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur de suppression' 
      };
    }
  }

  /**
   * Récupérer les photos d'un utilisateur
   * @param {number} userId - ID de l'utilisateur
   */
  async getUserPhotos(userId) {
    try {
      const response = await api.get('/get-user-photos.php', {
        params: { user_id: userId }
      });
      
      if (response.data.success) {
        return {
          success: true,
          photos: response.data.photos || [],
          total: response.data.total || 0
        };
      }
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.getUserPhotos - Erreur:', error);
      return { success: false, photos: [] };
    }
  }

  /**
   * Récupérer les vidéos d'un utilisateur
   * @param {number} userId - ID de l'utilisateur
   */
  async getUserVideos(userId) {
    try {
      const response = await api.get('/get-user-videos.php', {
        params: { user_id: userId }
      });
      
      if (response.data.success) {
        return {
          success: true,
          videos: response.data.videos || [],
          total: response.data.total || 0
        };
      }
      return response.data;
    } catch (error) {
      console.error('❌ ProfileService.getUserVideos - Erreur:', error);
      return { success: false, videos: [] };
    }
  }

  /**
   * Vérifier si l'utilisateur connecté suit ce profil
   * @param {number} profileId - ID du profil
   */
  async checkFollowing(profileId) {
    try {
      const userId = JSON.parse(localStorage.getItem('user') || '{}')?.id;
      if (!userId) return false;
      
      const response = await api.get('/check-following.php', {
        params: {
          follower_id: userId,
          following_id: profileId
        }
      });
      
      return response.data.isFollowing || false;
    } catch (error) {
      console.error('❌ ProfileService.checkFollowing - Erreur:', error);
      return false;
    }
  }

  /**
   * Calculer l'âge à partir de la date de naissance
   * @param {string} dateNaissance - Date de naissance
   */
  calculateAge(dateNaissance) {
    if (!dateNaissance) return 0;
    try {
      const today = new Date();
      const birthDate = new Date(dateNaissance);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    } catch (e) {
      console.error('❌ Erreur calcul âge:', e);
      return 0;
    }
  }

  /**
   * Formater une date
   * @param {string} dateString - Date à formater
   */
  formatDate(dateString) {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  }
}

// Créer une instance unique
const profileService = new ProfileService();
export default profileService;